export default {
  firstLetterCapital: string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
  firstLetterLower: string => {
    return string.charAt(0).toLowerCase() + string.slice(1);
  },
  currencyFormat: number => {
    return `$ ${number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
  },
  equalArrays: (a, b) => a.length === b.length && a.every((v, i) => v === b[i]),
  getUrlOrigin: url => {
    const urlInfo = new URL(url);

    // return the schema + hostname
    return urlInfo.origin;
  },
};
